import React from 'react';

const BS_Tooltip = () => {
    return (
        <div>
            <h1>BS_Tooltip Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Tooltip;
